import React, { useState } from "react";
import {
  Award,
  ChevronUp,
  ChevronDown,
  Trophy,
  Star,
} from "react-bootstrap-icons";
import CurrencyConverter from "../../Currency/CurrencyConverter";
import { useSelector } from "react-redux";
const NextRankCriteria = ({ data }) => {
  const [showDetails, setShowDetails] = useState(false);

  const currency = useSelector(
    (state) => state.user?.selectedCurrency
  );
  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );


  return (
    <div className="payout_overview_sec">
      <div className="rank-dashboard-container">
        {data?.isMax ? (
          <div className="rank-header-banner max-rank-banner">
          <div className="rank-title-container">
            <h6 className="rank-title max-rank-title">
              Maximum Rank Achieved!
            </h6>
          </div>
          
          {/* Added Top Rank Display */}
          <div className="top-rank-container">
           
            <div className="top-rank-content">
              {data?.rank?.image ? (
                <div className="top-rank-icon">
                  <img
                    style={{width:'6.5rem'}}
                    src={data?.rank?.image}
                    alt={"img"}
                  />
                </div>
              ) : (
                <div className="top-rank-icon">
                  <Trophy size={24} color="#gold" />
                </div>
              )}
              <div className="top-rank-name">
                <span className="rank-name-text1">{data?.rank?.name}</span>
              </div>
            </div>
          </div>
        
          <p className="rank-subtitle max-rank-subtitle">
            Congratulations! You've reached the highest Rank!
          </p>
        </div>
        ) : (
          <>
            {" "}
            <div className="rank-header-banner">
              <div className="rank-title-container">
                <h1 className="rank-title">
                  Next Rank: {data?.nextRank?.name}
                </h1>
              </div>
              <div className="rank-banner-content">
                {data?.nextRank?.image ? (
                  <div className="rank-icon-container">
                    <img src={data?.nextRank?.image}></img>
                  </div>
                ) : (
                  <div className="rank-icon-container">
                    <Award size={22} color="#fff" />
                  </div>
                )}
                <div className="rank-status-badge">
                  <span>{data?.totalPvRequirement?.percentage}% Complete</span>
                </div>
              </div>

              <p className="rank-subtitle" style={{ fontSize: "small" }}>
                Keep pushing to reach the next Rank!
              </p>
            </div>
            <div className="rank-main-content">
              <div className="rank-card summary-stats-card">
                <div className="rank-card-header">
                  <h3>Summary</h3>
                </div>
                <div className="charts-container">
                  <div className="stat-item current-pv">
                    <div className="stat-title">Qualified Volume</div>
                    <div className="stat-value">
                      <strong>{`${
                        currency?.symbolLeft ? currency?.symbolLeft : "$"
                      } ${CurrencyConverter(
                        data?.totalPvRequirement?.current ?? 0,
                        conversionFactor
                      )}`}</strong>
                    </div>
                  </div>

                  <div className="stat-item required-pv">
                    <div className="stat-title">
                      Required for {data?.nextRank?.name}
                    </div>
                    <div className="stat-value">
                      <strong>{`${
                        currency?.symbolLeft ? currency?.symbolLeft : "$"
                      } ${CurrencyConverter(
                        data?.totalPvRequirement?.required ??
                          0,
                        conversionFactor
                      )}`}</strong>
                    </div>
                  </div>

                  <div className="stat-item remaining-pv">
                    <div className="stat-title">Remaining Volume Needed</div>
                    <div className="stat-value">
                      <strong>{`${
                        currency?.symbolLeft ? currency?.symbolLeft : "$"
                      } ${CurrencyConverter(
                        data?.totalPvRequirement?.remaining ??
                          0,
                        conversionFactor
                      )}`}</strong>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <button
              className="toggle-details-btn"
              onClick={() => setShowDetails(!showDetails)}
            >
              {showDetails
                ? "Hide Detailed Breakdown"
                : "Show Detailed Breakdown"}
              {showDetails ? (
                <ChevronUp size={18} />
              ) : (
                <ChevronDown size={18} />
              )}
            </button>
            {showDetails && (
              <div className="rank-card details-card">
                <div className="rank-card-header">
                  <h3>Volume Distribution by Level</h3>
                </div>

                <div className="table-wrapper">
                  <table className="pv-table">
                    <thead>
                      <tr>
                        <th>Level</th>
                        <th>Total {currency?.symbolLeft ? currency?.symbolLeft : "$"}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Personal</td>
                        <td>{data?.pvBreakdown.personal.toLocaleString()}</td>
                      </tr>
                      {Object.entries(data?.pvBreakdown)
                        .filter(([key]) => key !== "personal")
                        .map(([key, value]) => {
                          const level = key.replace("level", "");
                          return (
                            <tr key={key}>
                              <td>Level {level}</td>

                              <td>{value.totalPv.toLocaleString()}</td>
                            </tr>
                          );
                        })}
                      <tr className="total-row">
                        <td>Total</td>

                        <td>
                          {data?.totalPvRequirement.current.toLocaleString()}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default NextRankCriteria;
